import React from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import { useParams } from 'react-router-dom'

import Loader from '../../components/loader/Loader'
import Header from '../../components/header'

import CancelStep1 from './CancelStep1'
import CancelStep2 from './CancelStep2'
import CancelStep3 from './CancelStep3'
import CancelStep4 from './CancelStep4'

import useAppointment from '../../hooks/appointment/useAppointment'
import useTranslation from '../../../utils/translation'

import { checkMeetingHasPassed } from '../appointment-details/utils'
import { isEmbedded } from '../bada/utils'

const MainContainer = styled.div`
  padding: 20px;
  max-width: 1097px;
  margin: 0px auto 400px auto;
`

const LoaderCover = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 10;
`

const LoaderContainer = styled.div`
  margin-top: 40vh;
`

export const ErrorMessage = styled.h1`
  font-family: ${theme('typography.paragraph.fontFamily')};
  font-family: ${theme('typography.amend.headline.fontFamily')};
  font-weight: ${theme('amend.error.fontWeight')};
  font-size: 36px;
  text-align: center;
  margin-top: 40px;
`

const validateAppointment = (appointment, step) => {
  const failedFetchingAppointment = !appointment
  if (failedFetchingAppointment) return 'appointment-not-found'

  const appointmentHasPassed = checkMeetingHasPassed(
    appointment.selectedDate,
    appointment.selectedTime
  )
  if (appointmentHasPassed) return 'appointment-passed'

  const appointmentTypeCanBeCanceled = appointment.selectedTime !== null
  if (!appointmentTypeCanBeCanceled) return 'not-slot-booking'

  const appointmentCanceled =
    appointment.simplyBookMeStatus === 'canceled' && step !== '3'
  if (appointmentCanceled) return 'appointment-canceled'

  return null
}

const CancelPage = () => {
  const t = useTranslation('cancel')
  const { appointmentId } = useParams()
  const { data: appointment, isLoading } = useAppointment(appointmentId)
  const step = new URLSearchParams(window.location.search).get('step')

  if (isLoading) {
    return (
      <LoaderCover>
        <LoaderContainer>
          <Loader duration={1} />
        </LoaderContainer>
      </LoaderCover>
    )
  }

  const errorMessage = validateAppointment(appointment, step)

  return (
    <>
      {!isEmbedded() && <Header />}
      <MainContainer>
        {errorMessage ? (
          <ErrorMessage>{t(errorMessage)}</ErrorMessage>
        ) : (
          (() => {
            switch (step) {
              case 1:
              default:
                return <CancelStep1 customerName={appointment.customerName} />
              case '2':
                return <CancelStep2 appointment={appointment} />
              case '3':
                return <CancelStep3 />
              case '4':
                return <CancelStep4 />
            }
          })()
        )}
      </MainContainer>
    </>
  )
}

export default CancelPage
